import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export function initI18n(): Promise<void> {
  return i18next
    .use(Backend)
    .use(LanguageDetector)
    .init({
      fallbackLng: 'en',
      debug: false,

      backend: {
        loadPath: '/assets/i18n/{{lng}}.json'
      },

      interpolation: {
        escapeValue: false
      }
    })
    .then(() => undefined);
}
